import { Component, Element, h, Host, Listen, Prop, State } from '@stencil/core';
// import {waitForElm} from '../../global/app'
import { isPlatform } from '@baloise/ds-core';

import { getLoginData, loggedOut, loggedIn } from '../../utils/auth.service';

// const buttons = [
//     {
//       icon: 'call',
//       popupId: 'popup-call',
//       touchPlacement: 'bottom',
//       ariaLabel: '24h Kundenservice',
//       htmlTitle: '24h Kundenservice',
//     },
//     {
//       label: 'DE',
//       popupId: 'popup-locale',
//       touchPlacement: 'bottom',
//       ariaLabel: 'Sprache wählen',
//       htmlTitle: 'Sprache wählen',
//     },
//     {
//       icon: 'search',
//       popupId: 'popup-search',
//       ariaLabel: 'Suchen',
//       htmlTitle: 'Suchen',
//     },
//     {
//       label: 'Anmelden',
//       icon: 'account',
//       popupId: 'login',
//       ariaLabel: 'Anmelden',
//       htmlTitle: 'Anmelden',
//     },
//     {
//       icon: 'location',
//       href: '/#',
//       target: '_blank',
//       ariaLabel: 'location',
//       htmlTitle: 'location',
//     },
// ]

// const optionLinkItems = [
//     {
//       value: 'privatkunden',
//       label: 'Privatkunden',
//       active: true,
//       mainLinkItems: [
//         {
//           value: 'Versichern',
//           label: 'Versichern',
//           active: false,
//           sectionLinkItems: [
//             {
//               value: 'Wohnen & Recht',
//               label: 'Wohnen & Recht',
//               href: '#',
//               active: false,
//               linkItems: [
//                 {
//                   value: 'Hausratversicherung',
//                   label: 'Hausratversicherung',
//                   clickable: true,
//                   active: false,
//                 },
//               ],
//             }
//           ],
//           serviceLinkItems: [
//             {
//               value: 'Services',
//               label: 'Services',
//               linkItems: [
//                 {
//                   value: 'Schaden melden',
//                   label: 'Schaden melden',
//                 },
//               ],
//             },
//             {
//               value: 'Finance 4 Women',
//               label: 'inance 4 Women',
//               color: 'red',
//               linkItems: [
//                 {
//                   value: 'Was macht eine gute Pensionskasse aus',
//                   label: 'Was macht eine gute Pensionskasse aus',
//                 },
//               ],
//             },
//           ],
//           overviewLink: {
//             value: 'Alle Versicherungslösungen ➞',
//             label: 'Alle Versicherungslösungen ➞',
//             href: 'http://localhost:3334/components/bal-nav/test/bal-nav.visual.html',
//           },
//         },
//         {
//           value: 'Konten, Karten & Finanzierung',
//           label: 'Konten, Karten & Finanzierung',
//           active: false,
//           sectionLinkItems: [
//             {
//               value: 'Sparen & Zahlen',
//               label: 'Sparen & Zahlen',
//               href: 'http://localhost:3334/components/bal-nav/test/bal-nav.visual.html',
//               active: false,
//               linkItems: [
//                 {
//                   value: 'Bankpakete',
//                   label: 'Bankpakete',
//                   clickable: true,
//                   active: false,
//                 },
//                 {
//                   value: 'Konten',
//                   label: 'Konten',
//                   clickable: true,
//                   active: false,
//                 },
//                 {
//                   value: 'Karten',
//                   label: 'Karten',
//                   clickable: true,
//                   active: false,
//                 },
//                 {
//                   value: 'Reisezahlungsmittel',
//                   label: 'Reisezahlungsmittel',
//                   clickable: true,
//                   active: false,
//                 },
//               ],
//             },
//             {
//               value: 'Finanzieren',
//               label: 'Finanzieren',
//               href: 'http://localhost:3334/components/bal-nav/test/bal-nav.visual.html',
//               active: false,
//               linkItems: [
//                 {
//                   value: 'Hypothek',
//                   label: 'Hypothek',
//                   href: '/',
//                   clickable: true,
//                   active: false,
//                 },
//                 {
//                   value: 'Baukredit',
//                   label: 'Baukredit',
//                   clickable: true,
//                   active: false,
//                 },
//                 {
//                   value: 'Privatkredit',
//                   label: 'Privatkredit',
//                   clickable: true,
//                   active: false,
//                 },
//               ],
//             },
//           ],
//           serviceLinkItems: [
//             {
//               value: 'Services',
//               label: 'Services',
//               linkItems: [
//                 {
//                   value: 'E-Banking erklärt',
//                   label: 'E-Banking erklärt',
//                   href: '/',
//                 },
//                 {
//                   value: 'Mobile Payment',
//                   label: 'Mobile Payment',
//                   href: '/',
//                 },
//                 {
//                   value: 'Bankkonditionen',
//                   label: 'Bankkonditionen',
//                   href: '/',
//                 },
//                 {
//                   value: 'Karte sperren',
//                   label: 'Karte sperren',
//                   href: '/',
//                 },
//               ],
//             },
//           ],
//           overviewLink: {
//             value: 'Alle Versicherungslösungen ➞',
//             label: 'Alle Versicherungslösungen ➞',
//             href: 'http://localhost:3334/components/bal-nav/test/bal-nav.visual.html',
//           },
//         },
//         {
//           value: 'Kontakt & Services', // Main Nav Link without submenu
//           label: 'Kontakt & Services',
//           href: '/',
//         }
//       ],
//     },
//     {
//       value: 'versicherungsprodukte',
//       label: 'Versicherungsprodukte',
//       active: true,
//       mainLinkItems: [
//         {
//           value: 'Versichern',
//           label: 'Versichern',
//           active: false,
//           sectionLinkItems: [
//             {
//               value: 'Wohnen & Recht',
//               label: 'Wohnen & Recht',
//               href: 'http://localhost:3334/components/bal-nav/test/bal-nav.visual.html',
//               active: false,
//               linkItems: [
//                 {
//                   value: 'Hausratversicherung',
//                   label: 'Hausratversicherung',
//                   clickable: true,
//                   active: false,
//                 },
//               ],
//             }
//           ],
//           serviceLinkItems: [
//             {
//               value: 'Services',
//               label: 'Services',
//               linkItems: [
//                 {
//                   value: 'Schaden melden',
//                   label: 'Schaden melden',
//                 },
//               ],
//             },
//             {
//               value: 'Finance 4 Women',
//               label: 'inance 4 Women',
//               color: 'red',
//               linkItems: [
//                 {
//                   value: 'Was macht eine gute Pensionskasse aus',
//                   label: 'Was macht eine gute Pensionskasse aus',
//                 },
//               ],
//             },
//           ],
//           overviewLink: {
//             value: 'Alle Versicherungslösungen ➞',
//             label: 'Alle Versicherungslösungen ➞',
//             href: 'http://localhost:3334/components/bal-nav/test/bal-nav.visual.html',
//           },
//         },
//         {
//           value: 'Blog', // Main Nav Link without submenu
//           label: 'Blog',
//           href: '/',
//         }
//       ],
//     }
// ]
// const logoLinkItem = {
//   href: 'https://www.baloise.ch',
//   ariaLabel: 'Homepage',
//   htmlTitle: 'Homepage'
// }

type MetNavButton = {
  label?: string;
  icon: string;
  popupId: string;
  touchPlacement: string;
  ariaLabel: string;
  htmlTitle: string;
};

@Component({
  tag: 'bam-navigation',
  styleUrl: 'bam-navigation.scss',
  shadow: false,
})
export class BamNavigation {
  @Element() host: HTMLElement;

  @Prop() logoLink?: string;
  @Prop() buttons!: string;
  @Prop() linkItems!: string;
  @Prop() authButtons: string;
  @Prop() loginUrl: string;
  @Prop() isEditMode: boolean = false;
  @Prop() pageNote: boolean = false

  @State() clickTarget;
  @State() clickLevel: 'meta' | 'main' | 'nav-link' | 'pop-up' | 'none';
  @State() activeMetaTab;
  @State() activeMainTab;

  @State() buttonsObject = [];
  @State() navLinksObject = [];
  @State() logoLinkObject = {};

  private loginButton: MetNavButton;
  private logoutButton: MetNavButton;

  @Listen('balNavItemClick')
  handleLinkClick(e) {
    setTimeout(() => {
      if (this.clickLevel === 'main') {
        this.activeMainTab = e.detail.label;
      }
      if (this.clickLevel === 'meta') {
        this.activeMetaTab = e.detail.label;
      }

      this.trackNavigation(e);
    }, 50);
  }

  @Listen('loggedOut')
  handleLogout() {
    this.toggleAuthButtons('loggedOut');
  }

  @Listen('balChange')
  handlePopver(event) {
    this.clickTarget = event.target;
    if (this.clickTarget.closest('.bal-nav-meta-bar')) {
      this.clickLevel = 'meta';
    } else if (this.clickTarget.closest('.bal-nav-menu-bar')) {
      this.clickLevel = 'main';
    } else if (this.clickTarget.classList.contains('bal-popup')) {
      this.clickLevel = 'pop-up';
    } else {
      this.clickLevel = 'none';
    }
    this.trackNavigation(event);
  }

  @Listen('click')
  handleClick(event) {
    this.clickTarget = event.target;

    if (this.clickTarget.closest('.bal-nav-link')) {
      this.clickLevel = 'nav-link';
    } else {
      this.clickLevel = 'none';
    }
  }

  trackNavigation(event) {
    const dataLayerObject = {
      event: 'component',
      componentStyle: 'link-list',
      componentContext: 'Main Navigation',
      componentTopic: event.detail.label || event.detail || '',
      componentActionArea: 'area',
      componentParentComponentId: `${this.activeMainTab}#Main Naviagtion`,
      componentDestinationURL: event.detail.href,
    };
    window.dataLayer.push(dataLayerObject);
  }

  toggleAuthButtons = (authState: 'loggedIn' | 'loggedOut', userName?: string) => {
    switch (authState) {
      case 'loggedOut':
        this.buttonsObject = this.buttonsObject.filter(button => button['popupId'] !== 'logout');
        this.buttonsObject = [...this.buttonsObject, this.loginButton];
        this.host.querySelector('bal-popup#logout')?.classList.add('hidden');
        loggedOut();
        break;
      case 'loggedIn':
        this.buttonsObject = this.buttonsObject.filter(button => button['popupId'] !== 'login');
        this.buttonsObject = [...this.buttonsObject, this.logoutButton];
        this.host.querySelector('bal-popup#login')?.classList.add('hidden');
        // Overwrite Fallback if User Name is set and not too long
        if ((isPlatform('widescreen') || isPlatform('fullhd')) && userName.length < 16) {
          this.logoutButton['label'] = userName;
        }
        loggedIn(userName);
        break;
      default:
        this.buttonsObject = this.buttonsObject.filter(button => button['popupId'] !== 'logout');
        this.buttonsObject = [...this.buttonsObject, this.loginButton];
        break;
    }
  };

  setUserAuth = async () => {
    this.loginButton = JSON.parse(this.authButtons).filter(button => button['popupId'] === 'login')[0];
    this.logoutButton = JSON.parse(this.authButtons).filter(button => button['popupId'] === 'logout')[0];
    // Testing
    // const data = {displayName: 'Gini'}
    const data = await getLoginData(this.loginUrl);
    if (!data) {
      this.toggleAuthButtons('loggedOut');
      return;
    }
    this.toggleAuthButtons('loggedIn', data.displayName);
  };

  connectedCallback() {
    if (this.logoLink) {
      this.logoLinkObject = JSON.parse(this.logoLink);
    }
    this.buttonsObject = JSON.parse(this.buttons);
    this.navLinksObject = JSON.parse(this.linkItems);
    this.activeMainTab = this.navLinksObject.filter(link => link.active)[0]?.label;

    if (this.authButtons) {
      this.setUserAuth();
    }
  }

  render() {
    return (
      <Host
        class={{
          'bam-navigation': true,
          'edit-mode': this.isEditMode,
          'has-page-note': this.pageNote
        }}
      >
        <bal-nav logo={this.logoLinkObject} buttons={this.buttonsObject} options={this.navLinksObject} content-width="440">
          <slot></slot>
        </bal-nav>
      </Host>
    );
  }
}
